module.exports = __webpack_public_path__ + "img/logo.a8599af5.png";